import { type ReactElement } from 'react';
import { TdsDivider } from '@scania/tegel-react';
import styles from './style.module.scss';
import { siteConfig } from '@/app/config/global';

const Header = (): ReactElement => (
  <div className={styles.container} data-testid="page-header">
    <h1>{siteConfig.subTitle}</h1>
    <TdsDivider className={styles.divider} />
  </div>
);

export default Header;
